export default [
    {
        el: '.j-title',
        langKey: 'title'
    },
    {
        el: '.j-term-text',
        langKey: 'termText'
    },
    {
        el: '.j-privacy-text',
        langKey: 'privacyText'
    },
]